import React, { FunctionComponent, useState } from 'react';

// MUI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// Common
import { GENERAL } from '../../../../constants';
import { types } from '../../../../types';

// Components
import { Tile } from '../../../Tile';
import { ModalSchool } from '../ModalSchool';

// Properties
import * as styles from './FormSchool.styles';

const FORM_FILE_NAME = 'karta_uczestnika_LS_aktywna_20_21.pdf';
const PATH_FORM_FILE = process.env.PUBLIC_URL + '/form-paper-version-2025.pdf';

const FormSchool: FunctionComponent = () => {
    const [ openModal, setModalStatus ] = useState(false);
    const [ chosenSchoolDetails, setSchoolDetails ] = useState<types.TSchool | null>(null);

    const handleOpenModal = () => setModalStatus(true);
    const handleCloseModal = () => setModalStatus(false);

    return (
        <Tile title={GENERAL.SCHOOL_TITLE}>
            {
                chosenSchoolDetails && (
                    <Box sx={styles.school}>
                        <Typography variant="body2">
                            {chosenSchoolDetails.name}
                        </Typography>
                        <Typography variant="body2">
                            {chosenSchoolDetails.address}
                        </Typography>
                    </Box>
                )
            }
            <Box>
                <Button
                    variant="contained"
                    onClick={handleOpenModal}
                >
                    {chosenSchoolDetails
                        ? GENERAL.SCHOOL_CHANGE_BUTTON
                        : GENERAL.SCHOOL_SELECT_BUTTON}
                </Button>
            </Box>
            <Box sx={styles.text}>
                <Typography variant="caption">
                    {GENERAL.SCHOOL_DESCRIPTION[1]}
                    <Link
                        underline="none"
                        href={PATH_FORM_FILE}
                        download={FORM_FILE_NAME}
                    >
                        {GENERAL.SCHOOL_DESCRIPTION[2]}
                    </Link>
                    {GENERAL.SCHOOL_DESCRIPTION[3]}
                    <br />
                    {GENERAL.SCHOOL_DESCRIPTION[4]}
                    <br />
                    {GENERAL.SCHOOL_DESCRIPTION[5]}
                    <Link
                        underline="none"
                        href={`mailto:${GENERAL.SCHOOL_EMAIL}`}
                    >
                        {GENERAL.SCHOOL_EMAIL}
                    </Link>
                    {GENERAL.SCHOOL_DESCRIPTION[6]}
                </Typography>
            </Box>
            {
                openModal && (
                    <ModalSchool
                        open={openModal}
                        onClose={handleCloseModal}
                        setSchoolDetails={setSchoolDetails}
                    />
                )
            }
        </Tile>
    );
};

export default FormSchool;
